import React, { ReactNode, useContext } from 'react';
import classNames from 'classnames';
import FmHeader from '../FmHeader';
import FmNavigation from '../FmNavigation';
import LayoutContext from 'providers/Layout/Layout.context';
import utils from 'utils';
import routes from '../../routes';
import CurrentUserContext from 'providers/CurrentUser';

import './DashPageWrapper.styles.scss';
import './DashPageWrapper.styles.responsive.scss';

type DashPageWrapperProps = {
  className?: string;
  children: ReactNode;
};

const appDashRoutes = utils.createNavRoute(
  routes.filter((route) => route.isDashRoute),
);

const ADMIN_ROUTES = ['users', 'fleets'];

const DashPageWrapper: React.FC<DashPageWrapperProps> = (props) => {
  const { children, className } = props;
  const { wrapperClass } = useContext(LayoutContext);
  const { isAdmin } = useContext(CurrentUserContext);

  const classes = classNames(wrapperClass, className);

  const filteredRoutes = appDashRoutes.filter(
    (route) => !ADMIN_ROUTES.includes(route.path) || isAdmin,
  );

  return (
    <div className={classes}>
      <FmHeader />
      <div className="dash-page-wrapper__content">
        <FmNavigation routes={filteredRoutes} />
        <div>
          <main>{children}</main>
        </div>
      </div>
    </div>
  );
};

export default DashPageWrapper;
